<template>
  <Container class="mb-24 mt-16 flex items-start space-x-6">
    <TabGroup
      v-if="isDesktop"
      vertical
      :selected-index="selectedTab"
      @change="changeTab">
      <TabList as="template">
        <SectionTabContainer>
          <Tab
            v-for="(tab, i) in tabs"
            :key="i"
            as="template">
            <SectionTabButton
              :icon="tab.icon"
              :title="tab.title"
              :selected-tab="selectedTab === i" />
          </Tab>
        </SectionTabContainer>
      </TabList>
      <TabPanels class="p-6">
        <TabPanel
          v-for="(tab, i) in tabs"
          :key="i">
          <SectionTabContent
            :content="tab.content"
            class="transition" />
        </TabPanel>
      </TabPanels>
    </TabGroup>

    <div v-else>
      <SectionTabContainer>
        <a
          v-for="(tab, i) in tabs"
          :key="i"
          :href="`#${slugify(tab.title, { lower: true })}`"
          class="block">
          <SectionTabButton
            :icon="tab.icon"
            :title="tab.title"
            :selected-tab="selectedTab === i" />
        </a>
      </SectionTabContainer>
      <div>
        <SectionTabContent
          v-for="(tab, i) in tabs"
          :id="slugify(tab.title, { lower: true })"
          :key="i"
          :content="tab.content"
          class="pt-16 transition" />
      </div>
    </div>
  </Container>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'

  import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/vue'
  import slugify from 'slugify'

  import { useScreenSize } from '../../composables/use-screen-size'

  defineProps<TabsProps>()

  const { isDesktop } = useScreenSize()

  type TabsProps = {
    tabs: {
      title: string
      icon: string
      content: {
        title: string
        copy: string
        accordion: {
          title: string
          content: string
        }[]
      }
    }[]
  }

  const selectedTab = ref(0)

  function changeTab(index: number) {
    selectedTab.value = index
  }
</script>
